import { useState } from "react";
import { MailCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useT } from "@/lib/i18n";

// Vraagt een nieuwe bevestigingsmail aan; zonder bekend e-mailadres toont het een invoerveld.
export function ResendVerificationButton({ email: presetEmail = "", compact = false }) {
  const t = useT();
  const [email, setEmail] = useState(presetEmail);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const send = async () => {
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/auth/resend-verification", { email, origin: window.location.origin });
      setSent(true);
      toast.success(t("Als dit adres bij ons bekend en nog niet bevestigd is, hebben we een nieuwe bevestigingsmail gestuurd."));
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={compact ? "" : "space-y-2"} data-testid="resend-verification">
      {!presetEmail && (
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("je@club.nl")}
          data-testid="resend-verification-email"
          className="w-full border-2 border-foreground bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary" />
      )}
      <button type="button" onClick={send} disabled={busy || sent || !email} data-testid="resend-verification-btn"
        className="btn-brutal bg-background text-foreground px-3 py-2 font-display uppercase font-bold text-xs inline-flex items-center gap-2 disabled:opacity-50">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <MailCheck className="w-3.5 h-3.5" />}
        {sent ? t("Verstuurd — controleer je inbox") : t("Bevestigingsmail opnieuw sturen")}
      </button>
    </div>
  );
}
